import { Chip } from '@mui/material';
import { ORDER_STATUS_COLORS } from '../constants/internalOrdersConstants';
import { formatOrderStatus } from '../utils/internalOrdersUtils';

const InternalOrderStatusChip = ({
  status,
  label,
  size = 'small',
  variant = 'outlined',
  ...chipProps
}) => {
  if (!status) return null;

  const displayLabel = label || formatOrderStatus(status);
  const color = ORDER_STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={displayLabel}
      color={color}
      size={size}
      variant={variant}
      {...chipProps}
    />
  );
};

export default InternalOrderStatusChip;
